module.exports = __webpack_public_path__ + "static/media/CAVOLINI.a09630ba.TTF";